<template>
  <div class="msg">
    <div v-html="handleFormatMsg(textMessageItem.msg)"></div>

    <div
      v-if="!textMessageItem.isme && (mobileList || wxList || qqList)"
      style="
        margin-top: 5px;
        border: 1px solid rgba(0, 0, 0, 0);
        background-color: rgba(0, 0, 0, 0);
        border-radius: 5px;
      ">
      <div class="btn_items">
        <el-button link type="primary" v-if="mobileList" @click.stop="handleSaveCustomMobile">
          <i class="iconfont icon-phone"></i>
          保存手机
          <el-tooltip
            class="box-item"
            effect="dark"
            content="手机空号检测"
            placement="top-start">
            <i
              @click.stop="handleCheckCustomMobile"
              style="font-size: 20px; color: #008b8b"
              class="iconfont icon-skintest"></i>
          </el-tooltip>
        </el-button>
        <el-button link type="primary" v-if="qqList" @click="handleSaveCustomQq">
          <i class="iconfont icon-QQ"></i>
          保存QQ
        </el-button>
      </div>

      <div class="operator_log_container">
        <div
          class="log_item"
          v-for="(log_item, index) in contactCheckList"
          :key="log_item.id">
          <div v-show="index == 0">
            <i class="iconfont icon-a-Arrow-Right2 prefix_icon"></i>
            {{ log_item.create_time }} {{ log_item.name }}
            <span :class="{ content_color: log_item.type == 2 || log_item.type == 3 }">
              {{ log_item.content }}
            </span>
            <span v-if="log_item.type == 2 || log_item.type == 3">
              <br />
              <span>{{ log_item.check_msg }}</span>
            </span>
            <el-button
              v-if="contactCheckList?.length > 1"
              link
              type="primary"
              style="font-size: 12px"
              @click="shoMoreOperatorLog = !shoMoreOperatorLog">
              更多记录
              <i
                class="iconfont icon-arrR"
                style="font-size: 12px"
                v-if="!shoMoreOperatorLog"></i>
              <i class="iconfont icon-arrD" style="font-size: 12px" v-else></i>
            </el-button>
          </div>

          <div v-if="index > 0 && shoMoreOperatorLog">
            <i class="iconfont icon-a-Arrow-Right2 prefix_icon"></i>
            {{ log_item.create_time }} {{ log_item.name }}
            <span :class="{ content_color: log_item.type == 2 || log_item.type == 3 }">
              {{ log_item.content }}
            </span>
            <span v-if="log_item.type == 2 || log_item.type == 3">
              <br />
              <span>{{ log_item.check_msg }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Teleport to="body">
  <!-- 保存用户联系方式 -->
  <el-dialog
    v-model="checkUserContactdialogVisible"
    title="用户联系方式保存"
    width="500"
    draggable
    @close="handleCloseUserContact">
    <div>
      <el-radio-group v-model="customContactToSave">
        <el-radio :value="item" v-for="(item, index) in customContactCheckList" :key="index">
          {{ item }}
        </el-radio>
      </el-radio-group>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="checkUserContactdialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveCustomContactDialog">保存</el-button>
      </div>
    </template>
  </el-dialog>

  <!-- 空号检测 -->
  <el-dialog
    v-model="testUserContactdialogVisible"
    title="空号检测"
    width="500"
    draggable
    @close="handleCloseUserContactTest">
    <div>
      <el-radio-group v-model="customContactToTest">
        <el-radio :value="item" v-for="(item, index) in customContactTestList" :key="index">
          {{ item }}
        </el-radio>
      </el-radio-group>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="testUserContactdialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleTestCustomContactDialog">检测</el-button>
      </div>
    </template>
  </el-dialog>
  </Teleport>
</template>
<script>
import { toRefs, onMounted, reactive, computed, ref, inject, onUnmounted } from "vue";
import { replaceEmoji } from "@/utils/emoji-util";
import { replaceXhsEmoji } from "@/utils/xhs-emoji-util";
import { saveCustomContact, checkCustomContact } from "@/api/chatapi";
import { customClueMatch } from "@/utils/commonUtils";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";

export default {
  props: {
    msgItem: {
      type: Object,
      default: () => ({}),
    },
    searchKeyWords: {
      type: String,
    },
  },
  setup(props) {
    const bus = inject("$eventBus");
    const eventbusCms = inject("eventbusCms");
    let store = useStore();
    const shoMoreOperatorLog = ref(false);
    let opLog = props.msgItem.operate_log || [];
    const contactCheckList = ref(opLog);
    const data = reactive({
      mobileList: [],
      wxList: [],
      qqList: [],
      contact_type: 0,
      checkUserContactdialogVisible: false,
      defaultDialogTitle: "用户联系方式保存",
      operatorStr: "",
      customContactCheckList: [],
      customContactToSave: "",
      testUserContactdialogVisible: false,
      customContactToTest: "",
      customContactTestList: [],
    });

    const chatingPlatId = computed(() => {
      let chatPlatId = store.state.chat_store.chat_plat_id;
      if (chatPlatId == -1) {
        chatPlatId = store.state.chat_store.user_account_select_friend?.plat_type;
      }
      return chatPlatId;
    });

    onUnmounted(() => {
      bus.off(eventbusCms.contact_check_change);
    });

    onMounted(() => {
      let matchResult = customClueMatch(props.msgItem.msg);
      data.mobileList = matchResult.mobileList;
      data.wxList = matchResult.wxList;
      data.qqList = matchResult.qqList;

      bus.on(eventbusCms.contact_check_change, handleContactCheckChange);
    });

    const handleContactCheckChange = async (resp) => {
      let msglist = resp.msglist || [];
      if (msglist.length > 0) {
        let _id = msglist[0].id;
        if (_id != props.msgItem.id) {
          return;
        }
        let _operate_log = msglist[0].operate_log || [];
        contactCheckList.value = _operate_log;
        if (resp.sc == 1) {
          ElMessage.success("空号检测完成");
        }
      }
    };

    const handleFormatMsg = (msg) => {
      if (!msg || typeof msg != "string") {
        return msg;
      }
      msg = msg.replace(/\n/g, "<br>");
      msg = msg.replace(/ /g, "&nbsp;");

      let platType = chatingPlatId.value;
      if (platType == 2) {
        msg = replaceXhsEmoji(msg);
      } else {
        msg = replaceEmoji(msg);
      }

      if (props.searchKeyWords) {
        msg = handleHighLightSearchMsg(msg, props.searchKeyWords);
      }
      return msg;
    };

    const handleHighLightSearchMsg = (msg, highlightStr) => {
      if (!msg) {
        return msg;
      }
      if (msg.includes("color:#008B8B")) {
        return msg;
      }

      if (msg.includes(highlightStr)) {
        let searchMsgH = `<span style='color:#008B8B'>${highlightStr}</span>`;
        msg = msg.replace(highlightStr, searchMsgH);
        return msg;
      }
      return msg;
    };

    const textMessageItem = computed(() => props.msgItem);

    const selectedAccountFriendId = computed(() => {
      return store.state.chat_store.user_account_select_friend?.cid;
    });

    const handleSaveCustomContact = (contact_type, contact) => {
      let sendData = {
        fid: selectedAccountFriendId.value,
        mid: props.msgItem.id,
        type: 1,
        contact_type: contact_type,
        contact: contact,
      };
      saveCustomContact(sendData);
    };

    const handleCheckCustomContact = (contact_type, contact) => {
      let sendData = {
        fid: selectedAccountFriendId.value,
        mid: props.msgItem.id,
        type: 2,
        contact_type: contact_type,
        contact: contact,
      };
      checkCustomContact(sendData);
    };

    const handleSaveCustomContactDialog = () => {
      let contact_type = data.contact_type;
      let contact = data.customContactToSave;

      if (!contact_type || !contact) {
        ElMessage.error("未找到用户联系方式信息");
        return;
      }
      data.checkUserContactdialogVisible = false;
      handleSaveCustomContact(contact_type, contact);
    };

    const handleTestCustomContactDialog = () => {
      let contact_type = data.contact_type;
      let contact = data.customContactToTest;

      if (!contact_type || !contact) {
        ElMessage.error("未找到用户联系方式信息");
        return;
      }
      data.testUserContactdialogVisible = false;
      handleCheckCustomContact(contact_type, contact);
    };

    const handleSaveCustomMobile = () => {
      if (!data.mobileList || data.mobileList.length == 0) {
        ElMessage.error("未找到用户手机号相关信息");
        return;
      }

      if (data.mobileList.length > 1) {
        data.customContactCheckList = data.mobileList;
        data.customContactToSave = data.customContactCheckList[0];
        data.contact_type = 1;
        data.checkUserContactdialogVisible = true;
        return;
      }
      handleSaveCustomContact(1, data.mobileList[0]);
    };

    const handleCheckCustomMobile = () => {
      if (!data.mobileList || data.mobileList.length == 0) {
        ElMessage.error("未找到用户手机号相关信息");
        return;
      }
      data.defaultDialogTitle = "手机号空号检测";

      if (data.mobileList.length > 1) {
        data.customContactTestList = data.mobileList;
        data.customContactToTest = data.customContactTestList[0];
        data.contact_type = 1;
        data.testUserContactdialogVisible = true;
        return;
      }
      handleCheckCustomContact(1, data.mobileList[0]);
    };

    const handleSaveCustomQq = () => {
      if (!data.qqList || data.qqList.length == 0) {
        ElMessage.error("未找到用户QQ号相关信息");
        return;
      }

      if (data.qqList.length > 1) {
        data.customContactCheckList = data.qqList;
        data.customContactToSave = data.customContactCheckList[0];
        data.contact_type = 3;
        data.checkUserContactdialogVisible = true;
        return;
      }
      handleSaveCustomContact(3, data.qqList[0]);
    };

    const handleCloseUserContact = () => {
      data.customContactCheckList = [];
      data.customContactToSave = "";
      data.contact_type = 0;
      data.defaultDialogTitle = "用户联系方式保存";
    };

    const handleCloseUserContactTest = () => {
      data.customContactTestList = [];
      data.customContactToTest = "";
      data.contact_type = 0;
    };

    return {
      ...toRefs(data),
      textMessageItem,
      shoMoreOperatorLog,
      contactCheckList,
      handleFormatMsg,
      handleSaveCustomMobile,
      handleSaveCustomQq,
      handleCloseUserContact,
      handleSaveCustomContactDialog,
      handleCheckCustomMobile,
      handleCloseUserContactTest,
      handleTestCustomContactDialog,
    };
  },
};
</script>

<style lang="scss" scoped>
.operator_log_container {
  color: #aaa;
  font-size: 12px;

  .log_item {
    padding: 2px 5px;

    .prefix_icon {
      color: black;
      font-size: 12px;
    }

    .content_color {
      color: #008b8b;
    }
  }
}
</style>
